/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FormattedHTMLMessage } from 'react-intl';
import { ToggleButtonGroup, ToggleButton } from 'react-bootstrap';

import paths from '../../../config/path';
import history from '../../../utils/history';
import BottomButtonsGroup from "../../../shared/AOForm/components/BottomButtonsGroup/index";

class AgreementFooter extends Component {
    constructor (props) {
        super(props);
        this.handleCheckBox = this.handleCheckBox.bind(this);
    }

    componentWillMount () {
        // Initialization data
        const params = {};
        params['isCheckBox'] = false;
        this.props.onHandleAgreement(params);
    }

    handleCheckBox (event) {
        const params = {};
        params['isCheckBox'] = event.target.checked;
        this.props.onHandleAgreement(params);
    }

    onClickNext = (value) => {
        this.props.sumbitApplication()
        .then(res => {
        })
        .catch(error => {
        });
    };

    onClickBack = (value) =>{
        history.push(paths.dashboard.path);
    };

    render () {
        const { agreement, dataId, agreementContent } = this.props;
        const isCheckBox = agreement.isCheckBox;
        // const showNum = isCheckBox ? 1 : 0;
        return (
            <div data-id={dataId} className="inner-page-content-footer">
                <div className="agreement-footer clearfix">
                    <div className="agreement-main">
                        <ToggleButtonGroup
                            type="checkbox"
                            className="checkbox-decoration"
                            // defaultValue={[showNum]}
                        >
                            <ToggleButton value={1} onChange={this.handleCheckBox}>
                                    <p className="agreement-txts">
                                    <FormattedHTMLMessage id="checkBoxValue" defaultMessage={agreementContent.baseContent.checkBoxValue} />
                                </p>
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </div>
                    <div className="dynamic-form quiescent-page">
                        <BottomButtonsGroup
                            content={{
                                completeForm:{
                                    text:agreementContent.baseContent.nextButton,
                                    dataKey:'nextButton'
                                },
                                back:{
                                    text:agreementContent.baseContent.backButton,
                                    dataKey:'backButton'
                                }
                            }}
                            disabled={!isCheckBox}
                            saveButtonShow={false}
                            completeFormAction={this.onClickNext}
                            backAction={this.onClickBack}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

AgreementFooter.propTypes = {
    dataId:PropTypes.string.isRequired
};

export default AgreementFooter;



// WEBPACK FOOTER //
// ./src/views/Agreement/components/StepFooter.js